import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';

import { AppModule } from './app/app.module';
import config from 'devextreme/core/config';
import { licenseKey } from 'devextreme-license';

if (environment.production || environment.integration) {
  enableProdMode();
}

// DevExtreme License...
config({ licenseKey });

platformBrowserDynamic().bootstrapModule(AppModule)
  // eslint-disable-next-line no-console
  .catch(err => console.error(err));
